import React from 'react';
import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const Loader = () => {
  return (
    <Box display='flex' marginTop='10px' alignItems='flex-start' flexDirection='row'>
      <Box marginRight='10px' marginTop='5px' clone>
        <Skeleton variant='rect' height={30} width={30} />
      </Box>
      <Box display='flex' flexDirection='column' width='100%'>
        <Skeleton variant='text' width='100%' />
        <Skeleton variant='text' width='70%' />
      </Box>
    </Box>
  );
};

export default Loader;
